import getShopId from '@core/reducers/shop/selectors/getShopId';
import getPreferredDishes from '@services/preferredDishes/getPreferredDishes';
import getIsFetchingPreferredDishes from '@shopDetails/selectors/getIsFetchingPreferredDishes';
import { mapperProduct } from '@services/menu/niles/mapperV2';
import { FETCH_PREFERRED_DISHES } from '@shopDetails/actionTypes';
import { successAction } from '@utils/actions';
import { error as logError } from '@logger';

const type = FETCH_PREFERRED_DISHES;

const fetchPreferredDishes = () => async (dispatch, getState, axios) => {
  const state = getState();
  const isFetching = getIsFetchingPreferredDishes(state);
  const shopId = getShopId(state);

  if (!isFetching) {
    try {
      dispatch({ type });

      const { success, data, error } = await getPreferredDishes({
        axios,
        shopId,
      });

      if (success) {
        dispatch(
          successAction({
            type,
            payload: {
              ...data,
              products: data?.products?.map(mapperProduct),
            },
          }),
        );
      } else {
        logError('[FETCH_PREFERRED_DISHES]', { error });
      }
    } catch (error) {
      logError('[FETCH_PREFERRED_DISHES]', { error });
    }
  }

  return null;
};

export default fetchPreferredDishes;
